import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    height: "80vh",
    overflowX: "hidden",
  },
  headerCard: {
    paddingTop: 0,
  },
  stepperWrap: {
    padding: 0,
    overflowX: "hidden",
    "& .MuiStepper-root": {
      padding: theme.spacing(1.5, 0),
      backgroundColor: "transparent",
    },
    "& .MuiStepIcon-root": {
      color: "var(--total_row_boldbackground)",
      fontSize: 28,
      transition: "all 0.3s ease",
    },
    "& .MuiStepIcon-root.MuiStepIcon-active": {
      color: "var(--color-primary-main)",
      filter: "drop-shadow(0 2px 4px rgba(51, 122, 183, 0.35))",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "var(--color-primary-main)",
    },
    "& .MuiStepLabel-label": {
      fontSize: 12,
      fontWeight: 500,
      color: "var(--color-text-secondary)",
      marginTop: 6,
      transition: "color 0.2s ease",
    },
    "& .MuiStepLabel-label.MuiStepLabel-active, & .MuiStepLabel-label.MuiStepLabel-completed": {
      color: "var(--color-text-primary) !important",
      fontWeight: "600 !important",
      opacity: "1 !important",
    },
    "& .MuiStepLabel-label.MuiStepLabel-disabled": {
      color: "var(--color-text-secondary)",
    },
    "& .MuiStepConnector-line": {
      borderColor: "var(--total_row_boldbackground)",
      borderTopWidth: 2,
    },
    "& .MuiStepConnector-active .MuiStepConnector-line": {
      borderColor: "var(--color-primary-main)",
    },
    "& .MuiStepConnector-completed .MuiStepConnector-line": {
      borderColor: "var(--color-primary-main)",
    },
  },
  stepLabel: {
    color: "var(--color-text-secondary)",
    "&$stepLabelActive": {
      color: "var(--color-text-primary) !important",
      fontWeight: "600 !important",
      opacity: "1 !important",
    },
    "&$stepLabelCompleted": {
      color: "var(--color-text-primary) !important",
      fontWeight: "600 !important",
      opacity: "1 !important",
    },
  },
  stepLabelActive: {},
  stepLabelCompleted: {},
  formCard: {
    padding: theme.spacing(0.5, 2, 0),
    borderRadius: 0,
    border: "none",
    backgroundColor: "var(--color-background-paper)",
    boxShadow: "none",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
    width: "100%",
  },
  stepTitle: {
    marginBottom: theme.spacing(1.5),
    fontSize: 16,
    fontWeight: 600,
    color: "var(--color-text-primary)",
  },
  draftBanner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    border: "1px solid rgba(51, 122, 183, 0.3)",
    backgroundColor: "rgba(51, 122, 183, 0.05)",
    transition: "all 0.2s ease",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: theme.spacing(1.25),
      padding: theme.spacing(1.5),
    },
  },
  draftBannerContent: {
    minWidth: 0,
    flex: 1,
  },
  draftBannerTitle: {
    fontSize: 13,
    fontWeight: 700,
    marginBottom: theme.spacing(0.25),
    color: "var(--color-text-primary)",
  },
  draftBannerText: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
  },
  draftBannerActions: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "stretch",
      "& > *": {
        flex: 1,
      },
    },
  },
  searchBanner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(1.25, 2),
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    border: "1px solid #F59E0B",
    backgroundColor: "#FEF3C7",
    transition: "all 0.2s ease",
    position: "sticky",
    top: 0,
    zIndex: 10,
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
      gap: theme.spacing(1),
      padding: theme.spacing(1.25, 1.5),
      "& $draftBannerContent": {
        flex: "1 1 auto",
        minWidth: 0,
      },
      "& $draftBannerActions": {
        flex: "1 1 100%",
        justifyContent: "stretch",
        "& > *": {
          flex: 1,
        },
      },
    },
    'html[data-mode="dark"] &': {
      backgroundColor: "#451A03",
      border: "1px solid #B45309",
    },
    "& .MuiTypography-root": {
      color: "#92400E",
      'html[data-mode="dark"] &': {
        color: "#FBBF24",
      },
    },
    "& .MuiTypography-body2": {
      color: "#B45309",
      'html[data-mode="dark"] &': {
        color: "#FCD34D",
      },
    },
  },
  warningIcon: {
    color: "#D97706",
    'html[data-mode="dark"] &': {
      color: "#FBBF24",
    },
    fontSize: 20,
    flexShrink: 0,
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1.5, 0),
    backgroundColor: "var(--color-background-paper)",
    borderTop: "1px solid var(--total_row_boldbackground)",
    marginTop: "auto",
    flexShrink: 0,
    minHeight: 52,
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
      gap: theme.spacing(1),
      padding: theme.spacing(1.25, 0),
    },
    "& .MuiButton-containedPrimary": {
      borderRadius: 8,
      textTransform: "none",
      fontWeight: 600,
      padding: theme.spacing(0.75, 3),
      boxShadow: "0 1px 3px rgba(25, 118, 210, 0.3)",
      transition: "all 0.2s ease",
      "&:hover": {
        boxShadow: "0 4px 12px rgba(25, 118, 210, 0.4)",
        transform: "translateY(-1px)",
      },
    },
    "& .MuiButton-outlined": {
      borderRadius: 8,
      textTransform: "none",
      fontWeight: 500,
      borderColor: "var(--total_row_boldbackground)",
      color: "var(--color-text-secondary)",
      "&:hover": {
        borderColor: "var(--color-primary-main)",
        backgroundColor: "var(--total_row_background)",
      },
    },
  },
  actionButton: {
    minWidth: "140px",
    [theme.breakpoints.down("xs")]: {
      minWidth: 0,
      flex: 1,
    },
  },
  actionGroup: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flex: "1 1 100%",
      flexWrap: "wrap",
      "& > *": {
        flex: "1 1 auto",
      },
    },
  },
  feeModeWrap: {
    marginBottom: theme.spacing(0.5),
  },
  feeModeLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: "var(--color-text-secondary)",
    marginBottom: theme.spacing(0.25),
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  radioGroup: {
    flexDirection: "row",
    "& .MuiFormControlLabel-label": {
      fontSize: 13,
    },
  },
  booleanFieldWrap: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    paddingTop: theme.spacing(1),
  },
  booleanFieldLabel: {
    fontSize: 13,
    fontWeight: 600,
    color: "var(--color-text-primary)",
  },
  booleanFieldHelper: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
  },
  feeCard: {
    border: "1px solid var(--total_row_boldbackground)",
    borderRadius: 12,
    padding: theme.spacing(1.5),
    backgroundColor: "var(--color-background-default)",
    transition: "border-color 0.2s ease",
    "&:hover": {
      borderColor: "var(--total_row_boldbackground)",
    },
  },
  feeCardTitle: {
    fontSize: 13,
    fontWeight: 700,
    marginBottom: theme.spacing(0.75),
    color: "var(--color-text-primary)",
  },
  feeFieldWrap: {
    marginTop: theme.spacing(0.5),
  },
  loaderWrap: {
    minHeight: 240,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
  },
  loaderText: {
    fontSize: 13,
    color: "var(--color-text-secondary)",
    fontWeight: 500,
  },
  subSectionWrap: {
    marginBottom: theme.spacing(2.5),
  },
  subSectionTitle: {
    fontSize: 12,
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: "var(--color-primary-main)",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    "&::before": {
      content: '""',
      display: "inline-block",
      width: 3,
      height: 14,
      backgroundColor: "var(--color-primary-main)",
      borderRadius: 2,
    },
  },
  uploadFieldWrap: {
    border: "1px solid var(--total_row_boldbackground)",
    borderRadius: 12,
    padding: theme.spacing(1.5),
    transition: "border-color 0.2s ease",
    "&:hover": {
      borderColor: "var(--total_row_boldbackground)",
    },
  },
  uploadLabel: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: "var(--color-text-primary)",
  },
  fieldError: {
    color: theme.palette.error.main,
    fontSize: 12,
    marginTop: theme.spacing(0.75),
  },
  fieldsContainer: {
    overflowY: "auto",
    overflowX: "hidden",
    minHeight: 0,
    flex: 1,
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(0.5),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    'html[data-mode="dark"] & .MuiInputAdornment-positionEnd .MuiSvgIcon-root': {
      color: "#E5E7EB !important",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--total_row_boldbackground)",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--color-text-secondary)",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--color-primary-main)",
    },
    'html[data-mode="dark"] & .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: "rgba(255, 255, 255, 0.23)",
    },
    'html[data-mode="dark"] & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: "rgba(255, 255, 255, 0.5)",
    },
    "&::-webkit-scrollbar": {
      width: 5,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "var(--total_row_boldbackground)",
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "var(--color-text-secondary)",
    },
  },
  searchResultContainer: {
    position: "relative",
    width: "100%",
  },
  searchResultPaper: {
    position: "absolute",
    top: "calc(100% - 4px)",
    left: 0,
    right: 0,
    zIndex: 1300,
    maxHeight: 300,
    overflowY: "auto",
    boxShadow:
      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    borderRadius: "0 0 12px 12px",
    border: "1px solid var(--total_row_boldbackground)",
    borderTop: "none",
    backgroundColor: "var(--color-background-paper)",
  },
  searchResultHeader: {
    padding: theme.spacing(1, 2),
    backgroundColor: "var(--color-background-default)",
    borderBottom: "1px solid var(--total_row_boldbackground)",
    fontSize: 10,
    fontWeight: 700,
    color: "var(--color-text-secondary)",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  searchResultItem: {
    padding: theme.spacing(1.25, 2),
    borderBottom: "1px solid rgba(128, 128, 128, 0.1)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(128, 128, 128, 0.05)",
      "& $searchResultAction": {
        color: "var(--color-primary-main)",
        transform: "translateX(2px)",
      },
    },
    "&:last-child": {
      borderBottom: "none",
    },
  },
  searchResultInfo: {
    flex: 1,
    minWidth: 0,
  },
  searchResultAction: {
    color: "var(--color-text-secondary)",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
  },
  searchResultTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: "var(--color-text-primary)",
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  searchResultSubTitle: {
    fontSize: 11,
    color: "var(--color-text-secondary)",
    display: "block",
    marginTop: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  searchingSpinner: {
    color: "var(--color-primary-main)",
    marginLeft: 8,
  },
  searchIconButton: {
    color: "var(--color-text-secondary)",
    "&:hover": {
      color: "var(--color-primary-main)",
      backgroundColor: "var(--total_row_background)",
    },
    'html[data-mode="dark"] &': {
      color: "#E5E7EB",
      "&:hover": {
        color: "var(--color-primary-main)",
      },
    },
  },
  searchCountBadge: {
    marginTop: theme.spacing(0.5),
    fontSize: 11,
    fontWeight: 600,
    color: "#059669",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    "& svg": {
      fontSize: 14,
    },
  },
  searchResultLoading: {
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    color: "var(--color-text-secondary)",
    fontSize: 12,
  },
  searchResultEmpty: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: "var(--color-text-secondary)",
    fontSize: 12,
  },
  egCreateWrap: {
    padding: theme.spacing(1.5, 2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  egCreateHint: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
    fontStyle: "italic",
  },
}));

export default useStyles;
